import { render, staticRenderFns } from "./printdischargepatient.vue?vue&type=template&id=1a49d086"
import script from "./printdischargepatient.vue?vue&type=script&lang=js"
export * from "./printdischargepatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports